
export class EventEmitter {
  private events: Map<string, Set<(data: any) => void>> = new Map();

  on(event: string, callback: (data: any) => void) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }
    this.events.get(event)?.add(callback);
  }

  off(event: string, callback: (data: any) => void) {
    this.events.get(event)?.delete(callback);
  }

  emit(event: string, data: any) {
    this.events.get(event)?.forEach(callback => callback(data));
  }
}

const localStorageEventEmitter = new EventEmitter();

export default class LocalStorage  {
  static setItem(key: string, value: string) {
    localStorage.setItem(key, value);
    localStorageEventEmitter.emit(key, value);
  }

  static setTemplateCenterVisited(isVisited: boolean) {
    this.setItem('FABRA_TEMPLATE_CENTER_VISITED', isVisited.toString());
  }

  static getTemplateCenterVisited() {
    return localStorage.getItem('FABRA_TEMPLATE_CENTER_VISITED') === 'true';
  }

  static setUserGuideVisited(isVisited: boolean) {
    this.setItem('chengzi8_user-guide-line-toggle', isVisited.toString());
  }

  static getUserGuideVisited() {
    return localStorage.getItem('chengzi8_user-guide-line-toggle') === 'true';
  }

  static onUserGuideVisitedChange(callback: (isVisited: boolean) => void) {
    localStorageEventEmitter.on('chengzi8_user-guide-line-toggle', (isVisited) => {
      callback(isVisited === 'true');
    });
  }
}
